import React from 'react';
import SMS from '../../components/sms/SMS';


const SMSList = props => {    

    return (
        <div className="container">
            <SMS clientId={0}/>
        </div>
    );
}

export default SMSList;
